export function MockMaintenanceListPortal() {
    return [
        {
            'name': 'customer-portal',
            'displayName': 'Customer Portal',
            'publicUrl': '',
        },
        {
            'name': '4pl-portal',
            'displayName': '4PL Portal',
            'publicUrl': '',
        },
        {
            'name': 'agent-portal',
            'displayName': 'Agent Portal',
            'publicUrl': '',
        },
    ];
}

export function MockMaintenanceGetJson() {
    return [
        {
            "begins": "2023-06-07T11:00:00-07:00",
            "windowStart": "2023-06-07T11:00:00-07:00",
            "windowEnd": "2023-06-08T12:00:00-07:00",
            "expires": "2023-06-08T12:00:00-07:00",
            "portals": ["customer", "customer"],
            "message": "The portal will not be available from :windowStart to :windowEnd for major maintenance. We apologize for the disruption and thank you for your patience while we work to improve our systems."
        },
        {
            "begins": "2023-10-07T11:00:00-07:00",
            "windowStart": "2023-10-07T11:00:00-07:00",
            "windowEnd": "2023-10-08T12:00:00-07:00",
            "expires": "2023-10-08T12:00:00-07:00",
            "portals": ["agent"],
            "message": "The system is current undergoing major maintenance. We expect services to resume by :windowEnd. We apologize for the disruption and thank you for your patience while we work to improve our systems."
        },
        {
            "begins": "2024-10-14T03:00:00-08:00",
            "windowStart": "2024-10-20T02:00:00-08:00",
            "windowEnd": "2024-10-20T05:00:00-08:00",
            "expires": "2024-10-20T05:00:00-08:00",
            "portals": [],
            "message": "This site will be down between :windowStart and :windowEnd for system maintenance. We apologize for the inconvenience."
        }
    ];
}
